import React, { Component } from 'react';
import { Spinner } from 'react-bootstrap';
import {stopSuperViseChat, superViseChat} from "../../actions/actions"



class SuperViseChatButton extends Component {

    constructor(props) {

        super(props);
        this.superViseChat=this.superViseChat.bind(this);
        this.closeSupervised=this.closeSupervised.bind(this);
        this.openSupervise=this.openSupervise.bind(this);
        this.state={
            "supervise":true
        }
    }

    superViseChat(id){
		console.log("tıklandı");
        if(this.state.supervise===true){
			console.log("başlıyor");
            this.props.dispatch(superViseChat(id));
			console.log("fonksiyon çalıştı:"+id);
            this.setState({
                supervise:false
            });
            setTimeout(this.openSupervise, 1000);

        }

    }
    closeSupervised(id){
        this.props.dispatch(stopSuperViseChat(id));

    }
    openSupervise(){
        this.setState({
            supervise:true
        });

    }
    render() {



        const { t } = this.props;
        return (
            <React.Fragment>
                {this.props.rowData.chat.agent != this.props.chatprop.operator.id &&
                    <React.Fragment>
                        {typeof this.props.rowData.chat.supervised === "undefined" &&

                                <a
                                    className="btn btn-outline-secondary btn-md"
                                    onClick={() => this.superViseChat(this.props.rowData.chat.chat_id)}
                                >
                                    {this.state.supervise === true &&
                                    <span>Supervise Chat</span>
                                    }
                                    {this.state.supervise === false &&
                                    <span>Processing <Spinner animation="border" variant="warning"/></span>
                                    }
                                </a>
                        }
                        {typeof this.props.rowData.chat.supervised !== "undefined" &&
                            <React.Fragment>
                                <a
                                    className="btn btn-outline-secondary btn-md mr-1"
                                    onClick={() => this.props.gotoChat(this.props.rowData.chat.chat_id)}

                                >Go To Chat</a>
                                <a
                                className="btn btn-secondary btn-md close-supervise-button"
                                onClick={() => this.closeSupervised(this.props.rowData.chat.chat_id)}

                                ><i className="bx bx-x"></i></a>
                            </React.Fragment>
                        }

                    </React.Fragment>
                }




            </React.Fragment>


        );
    }
}




export default SuperViseChatButton;


